import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 12px;
`;

export default Container;
